/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/no-multi-comp */
import React, { useEffect, useState } from 'react';
import { Grid, TableCell } from '@mui/material';
import { TableWidgetV2 } from '../../../../components/v2';
import ProdutoTamanhoFormulario from './ProdutoTamanhoFormulario';

const ProdutoTamanhoTable = ({ tamanhos, onSave, showError }) => {
  const [titles] = useState(['Tamanho', 'Ativo', 'Quantidade']);
  const [currentTamanhos, setCurrentTamanhos] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedTamanho, setSelectedTamanho] = useState(null);

  useEffect(() => {
    if (tamanhos) {
      setCurrentTamanhos(tamanhos);
    }
  }, [tamanhos]);

  const renderRows = p => {
    return (
      <>
        <TableCell>{p.tamanho}</TableCell>
        <TableCell>{p.ativo === "true" || p.ativo === true ? "Sim" : "Não"}</TableCell>
        <TableCell>{p.quantidade || 0}</TableCell>
      </>
    );
  };

  const onDeleteLocal = id => {
    const updatedTamanhos = currentTamanhos.filter(p => p.id !== id);
    setCurrentTamanhos(updatedTamanhos);
    onCloseLocal(updatedTamanhos);
  };

  const onCloseLocal = tamanhosToRetrieve => {
    setOpen(false);
    setSelectedTamanho(null);
    onSave(tamanhosToRetrieve || currentTamanhos);
  };

  const onUpsertTamanho = data => {
    let newTamanhos = [];

    const existedTamanhos = currentTamanhos.filter(p => p.id === data.id);
    if (existedTamanhos.length > 0) {
      currentTamanhos.forEach(p => {
        if (p.id === data.id) {
          newTamanhos.push(data);
        } else {
          newTamanhos.push(p);
        }
      });
    } else {
      newTamanhos = [...currentTamanhos, data];
    }

    setCurrentTamanhos(newTamanhos);
    onCloseLocal(newTamanhos);
  };

  const onEdit = id => {
    setSelectedTamanho(currentTamanhos.filter(p => p.id === id)[0]);
    setOpen(true);
  };

  return (
    <>
      <Grid size={{ xs: 12 }}>
        <TableWidgetV2
          rows={currentTamanhos}
          titles={titles}
          headerTitle="Tamanhos do Produto"
          deleteMessage="Tem certeza que deseja remover o tamanho do produto"
          renderRows={renderRows}
          hasRowActions
          onDelete={onDeleteLocal}
          onEdit={onEdit}
          onAdd={() => setOpen(true)}
          showError={showError}
          showEmptyState={false}
        />
      </Grid>
      <ProdutoTamanhoFormulario
        selectedTamanho={selectedTamanho}
        open={open}
        onClose={onCloseLocal}
        onSave={onUpsertTamanho}
      />
    </>
  );
};

export default ProdutoTamanhoTable;
